import { Tag } from 'foundations-components/transitional/components/Tag';
import { getSLATagColorFromStatus, getSLAIconColorTokenFromStatus } from 'conversations-internal-schema/sla/operators/getSLAColorFromStatus';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SLADueDate } from '../_internal/components/SLADueDate';
import { TimeIcon } from 'foundations-assets';
import { SLADueDatePreview } from '../_internal/components/SLADueDatePreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ActiveSLAAlert = ({
  activeSLA,
  isPreviewPanel
}) => {
  const tagColor = getSLATagColorFromStatus(activeSLA.status);
  const iconColor = getSLAIconColorTokenFromStatus(activeSLA.status);
  return /*#__PURE__*/_jsxs(Tag, {
    use: tagColor,
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: TimeIcon,
      color: iconColor,
      padding: "0",
      paddingBlock: "100",
      marginInlineEnd: "100"
    }), isPreviewPanel ? /*#__PURE__*/_jsx(SLADueDatePreview, {
      slaStatus: activeSLA.status
    }) : /*#__PURE__*/_jsx(SLADueDate, {
      slaCategory: activeSLA.category,
      dueDate: activeSLA.dueDate,
      slaStatus: activeSLA.status
    })]
  });
};
ActiveSLAAlert.displayName = 'ActiveSLAAlert';